import styled from '@emotion/styled';
import Box from './layouts/Box';

const Placeholder = styled(Box)();

Placeholder.defaultProps = {
  maxWidth: 1024,
  p: 'l',
  bg: 'white',
  border: 'dashed',
  borderRadius: 4,
  textAlign: 'center',
  fontSize: 'm',
  fontWeight: 'bold',
  color: 'secondaryFont',
};

export default Placeholder;
